module.exports = new __parcel__URL__("kuma_ancestor_shrine_level_1.1b03d0f3.png").toString();